<template>
  <div>
    <v-container fluid>
      <base-material-card
        icon="mdi-clipboard-text"
        title="รายละเอียดผู้ยื่นย้าย สายบริหาร"
      >
        <v-row>
          <v-col cols="12" md="8">
            <v-alert type="info" dense outlined class="mb-2">
              <strong>ขั้นตอนการดำเนินการ</strong><br />
              1. ให้สถานศึกษาประชุมพิจารณาจากแบบเสนอย้ายของผู้เสนอแต่ละราย<br />
              2. เมื่อพิจารณาเสร็จสิ้น ให้ดำเนินการผ่านระบบ Icon สีเหลือง<br />
              &nbsp;&nbsp;&nbsp;2.1 บันทึกความคิดเห็น<br />
              &nbsp;&nbsp;&nbsp;2.2 แนบไฟล์ผลการพิจารณา (หนังสือนำส่ง วาระการประชุม ผลการพิจารณา) เป็นไฟล์ PDF 1 ไฟล์
            </v-alert>
          </v-col>
          <v-col cols="12" md="4">
            <v-alert type="error" dense outlined>
              <strong>* สายบริหารจะปรากฏเมื่อผู้เสนอย้ายเข้า</strong><br />
              ปิดระบบวันที่ :
              <strong>{{ periods.period_college_stop | moment("D MMMM YYYY") }}</strong>
            </v-alert>
          </v-col>
        </v-row>

        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="ค้นหา ระบุคำ หรือ ส่วนข้อความเกี่ยวข้อง"
          single-line
          hide-details
          dense
          filled
          class="mb-2"
        />

        <v-data-table
          :loading="loading"
          :headers="headers"
          :items="transference_manage_locations"
          :search="search"
        >
          <template v-slot:item="{ item, index }">
            <tr>
              <td class="text-center">
                <v-checkbox
                  v-model="search_college"
                  :value="item.manage_id_ref"
                ></v-checkbox>
              </td>
              <td class="text-center">{{ index + 1 }}</td>
              <td class="text-center">{{ item.manage_id_ref }}</td>
              <td class="text-center">{{ item.title_s }}</td>
              <td class="text-center">{{ item.frist_name }}</td>
              <td class="text-center">{{ item.last_name }}</td>
              <td class="text-center">{{ item.college_code_now }}</td>
              <td class="text-center">{{ item.college_name_now }}</td>
              <td class="text-center">{{ item.tlcollege_code }}</td>
              <td class="text-center">
                <v-chip>
                  <span style="font-size:16px;">{{ item.college_name }}</span>
                </v-chip>
              </td>
              <td class="text-center">{{ item.time_ss + "/" + item.year_ss }}</td>
              <td class="text-center">{{ item.manage_age_app_time }}</td>
              <td class="text-center">
                <v-btn
                  v-if="item.manage_case_move === 'special'"
                  text color="info"
                  :href="'#/user/print_info_manage_d/' + item.manage_id_ref"
                  target="_blank"
                ><v-icon large>mdi-printer</v-icon></v-btn>
                <v-btn
                  v-else
                  text color="info"
                  :href="'#/user/print_info_manage/' + item.manage_id_ref"
                  target="_blank"
                ><v-icon large>mdi-printer</v-icon></v-btn>
              </td>
              <td class="text-center">
                <!-- แสดงสถานะความคิดเห็น -->
                <template v-if="item.Mcommittee === 'approp'">
                  <div class="d-flex flex-column align-center" style="gap:4px;">
                    <v-chip color="green" dark style="cursor:pointer;"
                      @click.stop="openPdfDialog(item)"
                    >
                      <v-icon left>mdi-check-circle</v-icon>
                      เห็นควรให้รับย้าย
                      <v-icon right small>mdi-file-pdf-box</v-icon>
                    </v-chip>
                    <v-btn
                      v-if="isWithinPeriod"
                      x-small color="red" text
                      @click.stop="openCancelOpinionDialog(item)"
                    >
                      <v-icon small>mdi-undo</v-icon> ยกเลิก
                    </v-btn>
                  </div>
                </template>
                <template v-else-if="item.Mcommittee === 'inapprop'">
                  <div class="d-flex flex-column align-center" style="gap:4px;">
                    <v-chip color="warning" dark style="cursor:pointer;"
                      @click.stop="openPdfDialog(item)"
                    >
                      <v-icon left>mdi-close-circle</v-icon>
                      ไม่เห็นควรให้รับย้าย
                      <v-icon right small>mdi-file-pdf-box</v-icon>
                    </v-chip>
                    <v-btn
                      v-if="isWithinPeriod"
                      x-small color="red" text
                      @click.stop="openCancelOpinionDialog(item)"
                    >
                      <v-icon small>mdi-undo</v-icon> ยกเลิก
                    </v-btn>
                  </div>
                </template>
                <template v-else>
                  <v-icon
                    v-if="isWithinPeriod"
                    color="yellow darken-2"
                    large
                    @click.stop="select_idPosition(item.manage_id_ref, item.manage_location_id_tfl)"
                  >mdi-credit-card-plus</v-icon>
                  <v-chip v-else color="grey" dark small>ปิดระบบแล้ว</v-chip>
                </template>
              </td>
            </tr>
          </template>
          <v-alert slot="no-results" :value="true" color="error" icon="mdi-alert">
            ไม่พบผลลัพธ์ "{{ search }}" ที่คุณกำลังค้นหา.
          </v-alert>
        </v-data-table>
      </base-material-card>

      <!-- Dialog: บันทึกความคิดเห็น -->
      <v-layout row justify-center>
        <v-dialog v-model="positiondialog" persistent max-width="80%">
          <v-card class="mx-auto pa-6">
            <base-material-card
              color="yellow"
              icon="mdi-clipboard-text"
              title="ความคิดเห็นคณะกรรมการบริหารสถานศึกษา"
              class="px-5 py-3 text_google"
            ></base-material-card>
            <v-card-text>
              <v-form ref="updatepositionform" lazy-validation>
                <v-container>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-card outlined class="pa-3">
                        <div class="subtitle-2 grey--text">ข้อมูลผู้ยื่นย้าย</div>
                        <div><strong>รหัสอ้างอิง:</strong> {{ transference_manages_id_ref.manage_id_ref }}</div>
                        <div><strong>รหัสบัตรประชาชน:</strong> {{ transference_manages_id_ref.id_card }}</div>
                        <div>
                          <strong>ชื่อ-นามสกุล:</strong>
                          {{ transference_manages_id_ref.title_s }}{{ transference_manages_id_ref.frist_name }}
                          {{ transference_manages_id_ref.last_name }}
                        </div>
                        <div>
                          <strong>สถานศึกษาปัจจุบัน:</strong>
                          {{ transference_manages_id_ref.college_code }} {{ transference_manages_id_ref.college_name }}
                        </div>
                        <div><strong>เลขที่ตำแหน่งปัจจุบัน:</strong> {{ transference_manages_id_ref.id_position }}</div>
                      </v-card>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-card outlined class="pa-3">
                        <div class="subtitle-2 grey--text">ข้อมูลกำหนดการพิจารณาการย้าย</div>
                        <div>
                          <strong>ย้ายครั้งที่:</strong> {{ periods.period_college_times }}
                          <strong>ปี:</strong> {{ periods.period_college_year | moment("YYYY") }}
                        </div>
                        <div>
                          <strong>รอบการย้าย:</strong>                         
                          {{ periods.period_college_start }}
                          - {{ periods.period_college_stop  }}
                        </div>                  
                      </v-card>
                    </v-col>

                    <v-col cols="12" md="12">
                      <v-card elevation="2" class="pa-2">
                        <div class="subtitle-1"><strong>เหตุผลในการย้าย:</strong></div>
                        <div class="body-1">{{ transference_manage_location_s.manage_reason_detail }}</div>
                      </v-card>
                    </v-col>

                    <v-col cols="12" md="12">
                      <v-card elevation="2" class="pa-2">
                        <v-alert class="mx-auto text-center pa-2 ma-2" border="top" colored-border type="info" elevation="2">
                          <h2>ความคิดเห็น</h2>
                          <v-radio-group
                            v-model="transference_manage_location_s.manage_location_status_transfer"
                            row required
                            :rules="[v => !!v || 'กรุณาเลือกความคิดเห็น']"
                            align="center"
                          >
                            <v-radio value="approp">
                              <template v-slot:label>
                                <strong class="primary--text">เห็นควรให้รับย้าย</strong>
                              </template>
                            </v-radio>
                            <v-radio value="inapprop">
                              <template v-slot:label>
                                <strong class="warning--text">ไม่เห็นควรให้รับย้าย</strong>
                              </template>
                            </v-radio>
                          </v-radio-group>
                        </v-alert>
                        <v-col cols="12" md="12">
                          แนบไฟล์ผลการพิจารณา (PDF เท่านั้น)
                          <v-file-input
                            v-model="documentsLinkfiles"
                            accept=".pdf"
                            name="documentsLinkfiles"
                            color="deep-purple accent-4"
                            counter
                            label="ไฟล์ .pdf"
                            placeholder="เลือกแนบไฟล์ PDF"
                            prepend-icon="mdi-paperclip"
                            outlined rounded
                            :show-size="1000"
                            :rules="[v => !!v || 'กรุณาแนบไฟล์ PDF']"
                          >
                            <template v-slot:selection="{ index, text }">
                              <v-chip v-if="index < 2" color="deep-purple accent-4" dark label small>{{ text }}</v-chip>
                              <span v-else-if="index === 2" class="text-overline grey--text text--darken-3 mx-2">
                                +{{ files.length - 2 }} File(s)
                              </span>
                            </template>
                          </v-file-input>
                        </v-col>
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="12" class="text-center">
                      <v-alert type="warning" dense outlined>
                        * เมื่อกดบันทึกแล้วไม่สามารถแก้ไขเปลี่ยนแปลงได้ กรุณาตรวจสอบให้ถูกต้อง
                        (สามารถยกเลิกได้ในช่วงที่เปิดระบบเท่านั้น)
                      </v-alert>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn large @click.stop="positiondialog = false" rounded>
                <v-icon dark>mdi-close</v-icon> ยกเลิก
              </v-btn>
              <v-btn large color="green" @click.stop="updatepositionSubmit()" rounded :loading="saving">
                <v-icon dark>mdi-content-save</v-icon>&nbsp;บันทึก
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <!-- Dialog: ยกเลิกความคิดเห็น -->
      <v-layout row justify-center>
        <v-dialog v-model="cancelOpinionDialog" persistent max-width="60%">
          <v-card class="mx-auto pa-6">
            <base-material-card
              color="red"
              icon="mdi-undo-variant"
              title="ยกเลิกความคิดเห็นของสถานศึกษา"
              class="px-5 py-3 text_google"
            ></base-material-card>
            <v-card-text>
              <v-alert type="warning" prominent>
                <strong>คุณต้องการยกเลิกความคิดเห็นนี้ใช่หรือไม่?</strong>
              </v-alert>
              <v-card outlined class="pa-3 mt-3" v-if="cancelOpinionItem">
                <div><strong>รหัสอ้างอิง:</strong> {{ cancelOpinionItem.manage_id_ref }}</div>
                <div><strong>ชื่อ-นามสกุล:</strong> {{ cancelOpinionItem.title_s }}{{ cancelOpinionItem.frist_name }} {{ cancelOpinionItem.last_name }}</div>
                <div>
                  <strong>ความคิดเห็นเดิม:</strong>
                  <v-chip small :color="cancelOpinionItem.Mcommittee === 'approp' ? 'green' : 'warning'" dark class="ml-2">
                    {{ cancelOpinionItem.Mcommittee === 'approp' ? 'เห็นควรให้รับย้าย' : 'ไม่เห็นควรให้รับย้าย' }}
                  </v-chip>
                </div>
              </v-card>

              <v-textarea
                v-model="cancelReason"
                label="เหตุผลในการยกเลิก *"
                outlined
                rows="3"
                class="mt-4"
                :rules="[v => !!v || 'กรุณาระบุเหตุผล']"
                required
              ></v-textarea>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn large @click.stop="cancelOpinionDialog = false" rounded>
                <v-icon dark>mdi-close</v-icon> ปิด
              </v-btn>
              <v-btn large color="red" dark @click.stop="submitCancelOpinion()" rounded :loading="cancelling">
                <v-icon dark>mdi-undo-variant</v-icon>&nbsp;ยืนยันการยกเลิก
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <!-- Dialog: ดูไฟล์แนบ PDF -->
      <v-layout row justify-center>
        <v-dialog v-model="pdfDialog" max-width="90%" @click:outside="closePdfDialog">
          <v-card>
            <v-toolbar dense flat color="blue-grey darken-3" dark>
              <v-icon class="mr-2">mdi-file-pdf-box</v-icon>
              <v-toolbar-title class="subtitle-1">
                ไฟล์ผลการพิจารณา —
                <span v-if="pdfItem">{{ pdfItem.title_s }}{{ pdfItem.frist_name }} {{ pdfItem.last_name }}</span>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon :href="pdfUrl" target="_blank" title="เปิดในแท็บใหม่">
                <v-icon>mdi-open-in-new</v-icon>
              </v-btn>
              <v-btn icon @click="closePdfDialog">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text class="pa-2 pb-0" v-if="pdfItem">
              <v-row dense>
                <v-col cols="12" md="4">
                  <span class="caption grey--text">รหัสอ้างอิง:</span>
                  <strong class="ml-1">{{ pdfItem.manage_id_ref }}</strong>
                </v-col>
                <v-col cols="12" md="4">
                  <span class="caption grey--text">สถานศึกษาปัจจุบัน:</span>
                  <strong class="ml-1">{{ pdfItem.college_name_now }}</strong>
                </v-col>
                <v-col cols="12" md="4">
                  <span class="caption grey--text">ความคิดเห็น:</span>
                  <v-chip x-small dark class="ml-1"
                    :color="pdfItem.Mcommittee === 'approp' ? 'green' : 'warning'"
                  >{{ pdfItem.Mcommittee === 'approp' ? 'เห็นควรให้รับย้าย' : 'ไม่เห็นควรให้รับย้าย' }}</v-chip>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-text class="pa-0" style="height:78vh;">
              <iframe
                v-if="pdfDialog && pdfUrl"
                :src="pdfUrl"
                width="100%"
                height="100%"
                style="border:none; display:block;"
                type="application/pdf"
              >
                <v-alert type="warning" class="ma-4">
                  เบราว์เซอร์ของคุณไม่รองรับการแสดงผล PDF โดยตรง
                  <v-btn text color="primary" :href="pdfUrl" target="_blank">คลิกเพื่อเปิดไฟล์</v-btn>
                </v-alert>
              </iframe>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-layout>

      <!-- Dialog: Log การดำเนินการ -->
      <v-layout row justify-center>
        <v-dialog v-model="logDialog" max-width="90%">
          <v-card>
            <base-material-card
              color="blue-grey"
              icon="mdi-history"
              title="Log การดำเนินการ"
              class="px-5 py-3"
            ></base-material-card>
            <v-card-text>
              <v-data-table
                :headers="logHeaders"
                :items="actionLogs"
                dense
                :items-per-page="10"
              >
                <template v-slot:item.log_action="{ item }">
                  <v-chip small :color="getLogColor(item.log_action)" dark>
                    {{ item.log_action }}
                  </v-chip>
                </template>
              </v-data-table>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="logDialog = false">ปิด</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

    </v-container>

    <v-container fluid>
      <v-snackbar v-model="snackbar.show" top :timeout="snackbar.timeout" :color="snackbar.color">
        <v-icon large>{{ snackbar.icon }}</v-icon>
        <v-card-text>{{ snackbar.text }}</v-card-text>
        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="snackbar.show = false">Close</v-btn>
        </template>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value: "1",
      loading: false,
      saving: false,
      cancelling: false,
      ApiKey: "HRvec2021",
      branch_s: [],
      manage_id_ref: [],
      valid: true,
      canceldialog: false,
      positiondialog: false,
      cancelOpinionDialog: false,
      logDialog: false,
      pdfDialog: false,
      pdfItem: null,
      pdfUrl: "",
      cancelOpinionItem: null,
      cancelReason: "",
      clear_dataDialog: false,
      times_select: "",
      years_select: "",
      snackbar: {
        show: false,
        color: "",
        timeout: 5000,
        icon: "",
        text: ""
      },
      time_ss: [1, 2],
      year_ss: [2565, 2566, 2567, 2568, 2569, 2570],
      transference_manage_locations: [],
      edittransference_manage_location: {},
      search: "",
      search_college: "",
      pagination: {},
      singleSelect: false,
      selected: [],
      headers: [
        { text: "เลือก", align: "left", value: "select_item" },
        { text: "#", align: "center", value: "index" },
        { text: "Ref", align: "center", value: "manage_id_ref" },
        { text: "คำนำหน้า", align: "center", value: "title_s" },
        { text: "ชื่อ", align: "center", value: "frist_name" },
        { text: "นามสกุล", align: "center", value: "last_name" },
        { text: "ส.ปัจจุบัน (รหัส)", align: "center", value: "college_code_now" },
        { text: "ส.ปัจจุบัน", align: "center", value: "college_name_now" },
        { text: "ส.แห่งใหม่ (รหัส)", align: "center", value: "tlcollege_code" },
        { text: "ส.แห่งใหม่", align: "center", value: "college_name" },
        { text: "ครั้งที่/ปี", align: "center", value: "time_ys" },
        { text: "อายุงาน", align: "center", value: "manage_age_app_time" },
        { text: "แบบเสนอย้าย", align: "center", value: "printmidRef" },
        { text: "ความคิดเห็นกรรมการสถานศึกษา", align: "center", value: "Mcommittee" }
      ],
      logHeaders: [
        { text: "#", value: "log_id", align: "center" },
        { text: "รหัสอ้างอิง", value: "log_manage_id_ref", align: "center" },
        { text: "การดำเนินการ", value: "log_action", align: "center" },
        { text: "ความคิดเห็น", value: "log_committee", align: "center" },
        { text: "เหตุผล/หมายเหตุ", value: "log_remark", align: "left" },
        { text: "ผู้ดำเนินการ", value: "log_user", align: "center" },
        { text: "วันเวลา", value: "log_datetime", align: "center" }
      ],
      actionLogs: [],
      rowsperpage: [25, 50, 100, { text: "All", value: -1 }],
      transference_manage_locationstatus: [],
      transference_manage_locations_id_ref: [],
      conditons_transfer_successs: [],
      updatepositions_condition: {},
      conditons_transfer_success_del: [],
      man_powers: [],
      userstatus: {},
      updatepositions: {},
      man_powerss: [],
      colleges: [],
      data_select: [],
      provinces: [],
      regions: [],
      transference_manages_id_ref: [],
      period_college_times: [],
      periods: [],
      transference_manage_location_s: [],
      addreturn_man_power: {},
      man_power_cancel: {},
      documentsLinkfiles: null
    };
  },

  computed: {
    pages() {
      if (!this.pagination.rowsPerPage || !this.pagination.totalItems) return 0;
      return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage);
    },
    color() {
      return "cyan darken-3";
    },
    period_college_years() {
      return this.periods.period_college_year;
    },
    /** ตรวจสอบว่าอยู่ในช่วงเปิดระบบหรือไม่ */
    isWithinPeriod() {
      if (!this.periods.period_college_enable_file) return false;
      if (this.periods.period_college_enable_file !== "1") return false;
      const now = new Date();
      const stop = this.periods.period_college_stop
        ? new Date(this.periods.period_college_stop)
        : null;
      if (stop && now > stop) return false;
      return true;
    }
  },

  async mounted() {
    let result;
    result = await this.$http.post("collegetype.php", { ApiKey: this.ApiKey });
    this.collegetypes = result.data;

    result = await this.$http.post("college.php", { ApiKey: this.ApiKey });
    this.colleges = result.data;

    result = await this.$http.post("province.php", { ApiKey: this.ApiKey });
    this.provinces = result.data;

    result = await this.$http.post("region.php", { ApiKey: this.ApiKey });
    this.regions = result.data;

    await this.periodQuery();
  },

  methods: {
    async periodQuery() {
      let result_period = await this.$http.post("period_college.php", {
        ApiKey: this.ApiKey,
        period_college_id: "40103"
      });
      this.periods = result_period.data;

      if (this.periods.period_college_enable_file !== "1") {
        Swal.fire({
          icon: "error",
          title: "ยังไม่มีกำหนดการ",
          allowOutsideClick: false,
          allowEscapeKey: false
        }).then(async result => {
          if (result.isConfirmed) {
            this.$router.push("/college");
          }
        });
      } else {
        await this.transference_manage_locationQueryAll();
      }
    },

    async transference_manage_locationQueryAll() {
      this.loading = true;
      let userSession = JSON.parse(sessionStorage.getItem("user")) || 0;
      let result = await this.$http
        .post("transference_manage_location.php", {
          ApiKey: this.ApiKey,
          manage_time_s: this.periods.period_college_times,
          manage_year_s: this.periods.period_college_year,
          manage_location_college_code: userSession.user_name
        })
        .finally(() => (this.loading = false));
      this.transference_manage_locations = result.data;
    },

    async searchTimeYear() {
      this.loading = true;
      let result = await this.$http
        .post("transference_manage_location.php", {
          ApiKey: this.ApiKey,
          time_s: this.times_select,
          year_s: this.years_select
        })
        .finally(() => (this.loading = false));
      this.transference_manage_locations = result.data;
    },

    async select_idPosition(manage_id_ref, manage_location_id_tfl) {
      if (!this.isWithinPeriod) {
        this.showSnackbar("error", "mdi-lock", "ระบบปิดรับการบันทึกแล้ว");
        return;
      }

      let result_con = await this.$http.post("transference_manage.php", {
        ApiKey: this.ApiKey,
        manage_id_ref: manage_id_ref
      });
      this.transference_manages_id_ref = result_con.data;

      let result = await this.$http.post("transference_manage_location.php", {
        ApiKey: this.ApiKey,
        manage_location_id_tfl: manage_location_id_tfl
      });
      this.transference_manage_location_s = result.data;

      this.updatepositions = {};
      this.documentsLinkfiles = null;
      this.positiondialog = true;
    },

    async updatepositionSubmit() {
      if (!this.isWithinPeriod) {
        this.showSnackbar("error", "mdi-lock", "ระบบปิดรับการบันทึกแล้ว");
        return;
      }

      if (!this.$refs.updatepositionform.validate()) return;

      this.saving = true;
      let result = "";
      let uploaded = null;
      let userSession = JSON.parse(sessionStorage.getItem("user"));

      this.updatepositions.ApiKey = this.ApiKey;
      this.updatepositions.manage_location_id_tfl = this.transference_manage_location_s.manage_location_id_tfl;
      this.updatepositions.Mcommittee = this.transference_manage_location_s.manage_location_status_transfer;
      this.updatepositions.manage_location_id_ref = this.transference_manage_location_s.manage_id_ref;

      if (this.documentsLinkfiles) {
        let formData = new FormData();
        let filename =
          this.transference_manage_location_s.manage_id_ref +
          userSession.user_name +
          "collegeAssessment.pdf";
        formData.append("ApiKey", this.ApiKey);
        formData.append("file", this.documentsLinkfiles);
        formData.append("filename", "../HRvecfiles/" + filename);

        result = await this.$http.post("uploadfile.php", formData, {
          headers: { "Content-Type": "multipart/form-data" }
        });
        if (result.data.status == true) {
          this.updatepositions.MdocumentsLinkfile = filename;
          uploaded = true;
        } else {
          uploaded = false;
        }
      } else {
        uploaded = false;
      }

      try {
        let saveResult = await this.$http.post(
          "transference_manage_location.update.php",
          this.updatepositions
        );

        if (saveResult.data.status) {
          // บันทึก Log
          await this.writeLog({
            manage_id_ref: this.updatepositions.manage_location_id_ref,
            action: "บันทึกความคิดเห็น",
            committee: this.updatepositions.Mcommittee,
            remark: "บันทึกความคิดเห็น" + (uploaded ? " พร้อมแนบไฟล์" : " (ไม่มีไฟล์แนบ)"),
            user: userSession.user_name
          });

          Swal.fire({
            icon: "success",
            title: "ปรับปรุงข้อมูลเรียบร้อย",
            showConfirmButton: false,
            timer: 1500
          });
          this.transference_manage_locationQueryAll();
        } else {
          if (!uploaded) {
            Swal.fire({ icon: "warning", title: "ไฟล์ที่แนบไม่ถูกต้องหรือไม่มีไฟล์แนบ", showConfirmButton: false, timer: 1500 });
          } else {
            Swal.fire({ icon: "warning", title: "บันทึกข้อมูลผิดพลาด", showConfirmButton: false, timer: 1500 });
          }
        }
      } catch (e) {
        Swal.fire({ icon: "error", title: "เกิดข้อผิดพลาด กรุณาลองใหม่", text: e.message });
      } finally {
        this.saving = false;
        this.positiondialog = false;
      }
    },

    /** เปิด Dialog ดูไฟล์แนบ PDF */
    openPdfDialog(item) {
      if (!item.MdocumentsLinkfile) {
        this.showSnackbar("warning", "mdi-alert", "ไม่พบไฟล์แนบสำหรับรายการนี้");
        return;
      }
      this.pdfItem = item;
      this.pdfUrl = "/HRvecfiles/" + item.MdocumentsLinkfile;
      this.pdfDialog = true;
    },

    closePdfDialog() {
      this.pdfDialog = false;
      this.pdfItem = null;
      this.pdfUrl = "";
    },

    /** เปิด Dialog ยกเลิกความคิดเห็น */
    openCancelOpinionDialog(item) {
      if (!this.isWithinPeriod) {
        this.showSnackbar("error", "mdi-lock", "ระบบปิดรับการยกเลิกแล้ว");
        return;
      }
      this.cancelOpinionItem = item;
      this.cancelReason = "";
      this.cancelOpinionDialog = true;
    },

    /** ยืนยันการยกเลิกความคิดเห็น */
    async submitCancelOpinion() {
      if (!this.cancelReason || this.cancelReason.trim() === "") {
        this.showSnackbar("warning", "mdi-alert", "กรุณาระบุเหตุผลในการยกเลิก");
        return;
      }

      if (!this.isWithinPeriod) {
        this.showSnackbar("error", "mdi-lock", "ระบบปิดรับการยกเลิกแล้ว");
        return;
      }

      this.cancelling = true;
      let userSession = JSON.parse(sessionStorage.getItem("user"));

      try {
        let result = await this.$http.post("transference_manage_location.update.php", {
          ApiKey: this.ApiKey,
          manage_location_id_ref: this.cancelOpinionItem.manage_id_ref,
          Mcommittee: "",
          MdocumentsLinkfile: "",
          manage_location_status_transfer: ""
        });

        if (result.data.status) {
          // บันทึก Log การยกเลิก
          await this.writeLog({
            manage_id_ref: this.cancelOpinionItem.manage_id_ref,
            action: "ยกเลิกความคิดเห็น",
            committee: this.cancelOpinionItem.Mcommittee,
            remark: this.cancelReason,
            user: userSession.user_name
          });

          Swal.fire({
            icon: "success",
            title: "ยกเลิกความคิดเห็นเรียบร้อยแล้ว",
            showConfirmButton: false,
            timer: 1500
          });
          this.transference_manage_locationQueryAll();
        } else {
          Swal.fire({ icon: "warning", title: "เกิดข้อผิดพลาดในการยกเลิก", showConfirmButton: false, timer: 1500 });
        }
      } catch (e) {
        Swal.fire({ icon: "error", title: "เกิดข้อผิดพลาด", text: e.message });
      } finally {
        this.cancelling = false;
        this.cancelOpinionDialog = false;
        this.cancelOpinionItem = null;
      }
    },

    /** บันทึก Log ไปยัง API */
    async writeLog({ manage_id_ref, action, committee, remark, user }) {
      try {
        await this.$http.post("transference_manage_location_log.php", {
          ApiKey: this.ApiKey,
          log_manage_id_ref: manage_id_ref,
          log_action: action,
          log_committee: committee,
          log_remark: remark,
          log_user: user,
          log_ip: "" // server-side จะ capture IP เอง
        });
      } catch (e) {
        console.warn("Log write failed:", e);
      }
    },

    /** ดู Log ของรายการ */
    async viewLog(manage_id_ref) {
      try {
        let result = await this.$http.post("transference_manage_location_log.php", {
          ApiKey: this.ApiKey,
          query_manage_id_ref: manage_id_ref
        });
        this.actionLogs = result.data || [];
        this.logDialog = true;
      } catch (e) {
        this.showSnackbar("error", "mdi-alert", "ไม่สามารถโหลด Log ได้");
      }
    },

    getLogColor(action) {
      if (action === "บันทึกความคิดเห็น") return "green";
      if (action === "ยกเลิกความคิดเห็น") return "red";
      return "grey";
    },

    showSnackbar(color, icon, text) {
      this.snackbar.color = color;
      this.snackbar.icon = icon;
      this.snackbar.text = text;
      this.snackbar.show = true;
    },

    getColor() {
      return "green";
    }
  }
};
</script>